import InstalledEquipmentReport from '../../slices/report/InstalledEquipmentReport'
import StockReport from '../../slices/report/StockReport'
import AuditLogReport from '../../slices/report/AuditLogReport'

const reportReducer = {
    installedEquipmentReport: InstalledEquipmentReport,
    stockReport: StockReport,
    auditLogReport: AuditLogReport,
};

export default reportReducer;